var _rect, _rect2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "circle-rect ",
    x: 1,
    y: 1,
    width: 98,
    height: 98,
    rx: 49,
    stroke: "#898989",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "person-speaker-bg",
    d: "M82 50C82 67.6731 67.6731 82 50 82C32.3269 82 18 67.6731 18 50C18 32.3269 32.3269 18 50 18C67.6731 18 82 32.3269 82 50Z",
    fill: "#898989"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62 40C62 46.6274 56.6274 52 50 52C43.3726 52 38 46.6274 38 40C38 33.3726 43.3726 28 50 28C56.6274 28 62 33.3726 62 40Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 64.4591V75.4061C46.6076 87.3483 63.5865 80.382 70 75.4061V64.4591C70 59.2841 64.5992 56.6635 61.8987 56H38.6076C32.5316 56 30.3376 61.6394 30 64.4591Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUser);
export default __webpack_public_path__ + "static/media/default_user.93486af5.svg";
export { ForwardRef as ReactComponent };